import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { BankDetailsRepository } from '../../../../store/bank-details-state/bank-details-state.repository';

interface getBankDetailsDataTableStructureProps {
  store: BankDetailsRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getBankDetailsDataTableStructure = ({ store, createAction, rowActions }: getBankDetailsDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const agencyColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.agency',
    accessorKey: 'agence',
    variant: DataTableColumnVariant.TEXT,
  };
  const ribColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.rib',
    accessorKey: 'rib',
    variant: DataTableColumnVariant.TEXT,
  };
  const paysColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.country',
    accessorKey: 'pays.code',
    variant: DataTableColumnVariant.TEXT,
  };
  const localColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.bankDetails.table.local',
    accessorKey: 'local',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value === true ? 'Oui' : 'Non' };
    },
    props: {
      innerClass: 'px-3 py-1',
      getSeverity: (value: boolean) => {
        return value === true ? 'success' : 'danger';
      },
    },
  };

  return {
    singular: 'settings.bankDetails.table.singular',
    plural: 'settings.bankDetails.table.plural',
    columns: [idColumn, nameColumn, agencyColumn, ribColumn, paysColumn, localColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: any) => {
      store.set('response', row);
      store.set('dto', {
        nom: row.nom,
        agence: row.agence,
        rib: row.rib,
        paysId: row.pays.id,
        local: row.local,
      });
      store.set('bankDetailsCountrySelected', { name: row.pays.description, code: row.pays.id });
    },
    createAction,
    rowActions,
    searchableFields: ['id', 'nom', 'agence', 'rib', 'pays.description', 'local'],
  };
};
